module.exports = __webpack_public_path__ + "static/media/view manager.685a3cad.svg";